<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        .box
            span.descritivo.bold {{ $t('mensagens.laudos.selecioneAbaixoOCarVinculadoAoTerritorioParaQualDesejaLaudo') }}

            .options
                label.item(v-for='car in territorio.cars', :key='car.id')
                    el-checkbox(
                        :key='car.id',
                        @change='addToLaudos(car.id, territorio.id, $event)'
                    ) {{ car.codigo }}

            span.descritivo {{ $t('mensagens.laudos.casoCarDesejadoNaoEstejaNaListagem') }}
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import TipoLaudo from '@/constants/TipoLaudo';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CardDadosTerritorioConformidadeAmbiental',
    components: {
        BaseButton
    },
    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            laudos: []
        };
    },

    mounted() {
        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },

    watch: {
        '$v.dados.$invalid': function () {
            this.$emit('getValidacao', {
                valido: !this.$v.dados.$invalid,
                id: this.territorio.id
            });
            this.$emit('getDados', {
                dados: this.laudos,
                id: this.territorio.id
            });
        }
    },

    validations: {
        laudos: { required },
        dados: ['laudos']
    },

    methods: {
        addToLaudos(idCar, idTerritorio, checked) {
            if (checked) {
                this.laudos.push({
                    territorioId: idTerritorio,
                    carId: idCar,
                    tipoLaudoId: TipoLaudo.CONFORMIDADE
                });
            } else {
                this.laudos = this.laudos.filter(
                    l => !(l.territorioId === idTerritorio && l.carId === idCar)
                );
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .box {
        padding: 1rem 1.5rem;
        border-top: 1px solid var(--default-border-color);
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}

.descritivo {
    font-size: 14px;
}

.bold {
    font-weight: 500;
}

.options {
    margin: 1.5rem 0;
    display: flex;
    flex-wrap: wrap;
}

.item {
    overflow: auto;
    width: 400px;
}
</style>
